import { render, staticRenderFns } from "./majorscores.vue?vue&type=template&id=34b267f2&scoped=true"
import script from "./majorscores.vue?vue&type=script&lang=js"
export * from "./majorscores.vue?vue&type=script&lang=js"
import style0 from "./majorscores.vue?vue&type=style&index=0&id=34b267f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b267f2",
  null
  
)

export default component.exports